import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { ApiError, api } from "../lib/api";
import { EngineToggle } from "../components/EngineToggle";
import { PlanBadge } from "../components/PlanBadge";
const ENGINES = ["life", "health", "annuities"];
export default function AdminPanel() {
    const [tenant, setTenant] = useState(null);
    const [toggles, setToggles] = useState([]);
    const [error, setError] = useState(null);
    const [loading, setLoading] = useState(true);
    const [toast, setToast] = useState(null);
    useEffect(() => {
        (async () => {
            try {
                const t = await api.me();
                setTenant(t);
                const tg = await api.listEngines(t.id);
                const byId = Object.fromEntries(tg.map((x) => [x.engine_id, x]));
                const filled = ENGINES.map((id) => byId[id] ?? { engine_id: id, enabled: false, enabled_at: null });
                setToggles(filled);
            }
            catch (e) {
                setError(e instanceof ApiError ? e.message : String(e));
            }
            finally {
                setLoading(false);
            }
        })();
    }, []);
    if (loading)
        return _jsx("p", { className: "p-6 text-slate-500", children: "Loading\u2026" });
    if (error)
        return _jsxs("p", { className: "p-6 text-red-700", children: ["Error: ", error] });
    if (!tenant)
        return null;
    function updateToggle(next) {
        setToggles((prev) => prev.map((t) => (t.engine_id === next.engine_id ? next : t)));
    }
    function showUpgrade() {
        setToast(`Upgrade to ${tenant.plan_tier === "starter" ? "Pro" : "Enterprise"} to enable this engine.`);
        setTimeout(() => setToast(null), 4000);
    }
    return (_jsxs("div", { className: "mx-auto max-w-5xl p-4 sm:p-6", children: [_jsxs("header", { className: "mb-6 flex items-center justify-between", children: [_jsxs("div", { children: [_jsx("h1", { className: "text-2xl font-bold", children: "Engines" }), _jsxs("p", { className: "text-sm text-slate-600", children: ["Toggle which lead engines run for ", tenant.name, "."] })] }), _jsxs("div", { className: "flex items-center gap-2", children: [_jsx("span", { className: "text-sm text-slate-500", children: "Plan:" }), _jsx(PlanBadge, { tier: tenant.plan_tier })] })] }), _jsx("div", { className: "grid gap-4 sm:grid-cols-2 lg:grid-cols-3", children: toggles.map((t) => (_jsx(EngineToggle, { tenant: tenant, toggle: t, onChange: updateToggle, onUpgradeRequired: showUpgrade }, t.engine_id))) }), toast && (_jsx("div", { className: "fixed bottom-6 left-1/2 -translate-x-1/2 rounded-lg bg-amber-500 px-4 py-2 text-white shadow-lg", children: toast }))] }));
}
